const config = {
  development: {
    polygonChainId: [137, 80001],
    selectedChainId: 80001,
    apiURL: "http://34.100.133.253/api/v1/", /* for live server */
    // apiURL: "http://192.168.0.26:8000/api/v1/", "for local server",
    // /* 'http://192.168.0.26:8000/api/v1/', */
    // apiURL: 'https://www.gamingarcade.io/api/',
    //apiURL: 'https://96b6-2405-201-5c07-7845-77f2-af7a-7f7d-4b8a.in.ngrok.io/api/',
    tweetVerificationDeadlineInSeconds: 120,
    // oneVoneContract: "0x4032602465DD49F498c862a115A1041DB0339B19",
    oneVoneContract: "0x9365B91a67a109BB1523B1950534e7f3541991F8",
    tweetAPI: "https://twitter.com/intent/tweet?text=",
    sourceTweet: "https://twitter.com/rahu_lt/status/1536957581536600071",
    tournamentContract: "0x8f0adF42aa56832edCC0E4891892144a5fc72a62",
    moralisURL: "https://lxkqfulgryrg.usemoralis.com:2053/server",
    moralisAPIKey: "5HULnUofkE8mdbCGMeC1pmmtujx8w7bOzjMEV7IT",
  },
  production: {
    polygonChainId: [137],
    selectedChainId: 137,
    //apiURL: 'http://localhost:4000/api',00
    apiURL: "https://www.gamingarcade.io/api/",
    tweetVerificationDeadlineInSeconds: 120,
    oneVoneContract: "0x26ADA6532a74B57587744420Ca2aeF286628ACe0",
    tweetAPI: "https://twitter.com/intent/tweet?text=",
    sourceTweet:
      "https://twitter.com/GamingArcade_io/status/1539447426687602688",
    tournamentContract: "0x8f0adF42aa56832edCC0E4891892144a5fc72a62",
    moralisURL: "https://lxkqfulgryrg.usemoralis.com:2053/server",
    moralisAPIKey: "5HULnUofkE8mdbCGMeC1pmmtujx8w7bOzjMEV7IT",
  },
};

// export default config[process.env.NODE_ENV]
export default config[`development`];
